import DataTableV2 from "../../../../components/DataTable/DateTableV2";
import * as React from "react";
import { Badge, Button, Text } from "@chakra-ui/react";
import { getBadgeColor } from "../helper";
import { routes } from "../../../../config";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import { prettyPrintCodeName } from "utils/text-utils";
/**
 * Note: excluded dont get filtered out here, so showExcluded is not needed
 * @param {Question[]} questionList
 * @returns
 */
const QuestionCardTable = ({ questionList }) => {
  const navigate = useNavigate();

  const columns = [
    {
      header: "Question",
      accessorKey: "question",
      size: 300,
      cell: (row) => {
        const {
          row: { original: rowData },
        } = row;
        return <Text fontSize="body.xs">{rowData?.question}</Text>;
      },
    },
    {
      header: "Stage",
      accessorKey: "stage",
      size: 100,
      cell: (row) => {
        const {
          row: { original: rowData },
        } = row;
        return (
          <Badge px={2} py={1} borderRadius="md" fontSize="body.xxs" bg={getBadgeColor(rowData?.stageType)}>
            {prettyPrintCodeName(rowData?.stage)}
          </Badge>
        );
      },
    },
    {
      header: "Owner",
      accessorKey: "owner",
      size: 150,
      cell: (row) => {
        const {
          row: { original: rowData },
        } = row;
        return (
          <Badge px={2} py={1} borderRadius="md" fontSize="body.xxs" colorScheme="yellow">
            {rowData?.owner}
          </Badge>
        );
      },
    },
    {
      header: "Assignee",
      accessorKey: "assignee",
      size: 150,
      cell: (row) => {
        const {
          row: { original: rowData },
        } = row;
        return (
          <Badge px={2} py={1} borderRadius="md" fontSize="body.xxs" colorScheme="yellow">
            {rowData?.assignee || rowData?.owner}
          </Badge>
        );
      },
    },
    {
      header: "",
      accessorKey: "action",
      size: 50,
      cell: (row) => {
        const {
          row: { original: rowData },
        } = row;
        return (
          <Button
            size="lg"
            variant="link"
            rightIcon={<FaAngleRight />}
            onClick={() => navigate(`${routes.issbAnswerDetail}?id=${rowData?.id}`)}
          ></Button>
        );
      },
    },
  ];

  return (
    <DataTableV2
      data={questionList}
      columns={columns}
      serverSidePagination={false}
      containerHeight="var(--chakra-sizes-2xl)"
    />
  );
};

export default QuestionCardTable;
